var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.813 9h2.3l-5.025 5.93L23 23h-4.629l-3.625-4.894L10.598 23H8.296l5.375-6.343L8 9h4.746l3.277 4.473L19.813 9Zm-.807 12.578h1.275l-8.227-11.231h-1.368l8.32 11.231Z"
  })));
};
export default SvgTwitter;